import script from "./ProgramContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProgramContent.vue?vue&type=script&lang=ts&setup=true"

import "./ProgramContent.vue?vue&type=style&index=0&id=da25d3ae&scoped=true&lang=css"
import "./ProgramContent.vue?vue&type=style&index=1&id=da25d3ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da25d3ae"]])

export default __exports__